<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create Journalist</h1>
        </div>
        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="user-body">
                    <div class="form-field">
                        <label>First Name</label>
                        <input type="text" v-model="user.firstname" placeholder="First Name">
                    </div>
                    <div class="form-field">
                        <label>Last Name</label>
                        <input type="text" v-model="user.lastname" placeholder="Last Name">
                    </div>
                    <div class="form-field">
                        <label>Email</label>
                        <input type="email" v-model="user.email" placeholder="Email*">
                    </div>
                    <div class="form-field">
                        <label>Telephone</label>
                        <input type="text" v-model="user.telephone" placeholder="Telephone">
                    </div>
                    <div class="form-field">
                        <publication-selector
                            :publicationId="user.publication_id"
                            @input-publication-id="user.publication_id = $event"
                            @input-new-publication-title="newPublication.title = $event"
                            @input-new-publication-type="newPublication.type = $event"
                        >
                        </publication-selector>
                    </div>
                    <div class="form-field">
                        <label>Sectors</label>
                        <picker-selector
                            placeholder="Select Sectors"
                            v-model="user.sector"
                            :options="sectors">
                        </picker-selector>
                    </div>
                    <div class="form-field">
                        <label>Locations</label>
                        <picker-selector
                            placeholder="Select Locations"
                            v-model="user.location"
                            :options="locations">
                        </picker-selector>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="flex">

                <div class="middle text-middle">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="save">Save</button>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import {useStore} from "vuex"

export default {
    name: 'JournalistsCreate',
    components: {
    },
    data() {
        return {
            newPublication: {
                title: null,
                type: null,
            },
            user: {
                firstname: null,
                lastname: null,
                email: null,
                telephone: null,
                type: 'journalist',
                publication_id: null,
                location: null,
                sector: null,
                role: null
            }
        }
    },
    mounted() {
        this.setMetaTitle('Create Journalist | JournoLink Control')
    },
    methods: {
        save() {
            axios.post(route('journalists.store'), {user: this.user, newPublication:this.newPublication})
                .then(response => {
                    this.$bus.$emit('alert.success', 'Journalist creation Success')
                    this.closeView();
                })
                .catch(e => {
                    console.log({e});
                });
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
    },
    computed: {
        sectors () {
            const store = useStore()
            return store.state.sectors ?? []
        },
        locations () {
            const store = useStore()
            return store.state.locations ?? []
        },
    }
}
</script>

<style lang="less">

.user-body {
    flex: 1;
    padding: 15px;
}

</style>
